"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.PaperText = exports.PapersMinimalistic = exports.Papers = exports.PaperMedicine = exports.PaperAdd = exports.Paper = exports.NotesMinimalistic = exports.Notes = exports.Note = exports.ClipboardText = exports.ClipboardRemove = exports.ClipboardList = exports.ClipboardHeart = exports.ClipboardCheck = exports.ClipboardAdd = exports.Clipboard = exports.ArchiveUpMinimlistic = exports.ArchiveUp = exports.ArchiveMinimalistic = exports.ArchiveDownMinimlistic = exports.ArchiveDown = exports.ArchiveCheck = exports.Archive = void 0;
var Archive_1 = require("./Archive");
__createBinding(exports, Archive_1, "default", "Archive");
var ArchiveCheck_1 = require("./ArchiveCheck");
__createBinding(exports, ArchiveCheck_1, "default", "ArchiveCheck");
var ArchiveDown_1 = require("./ArchiveDown");
__createBinding(exports, ArchiveDown_1, "default", "ArchiveDown");
var ArchiveDownMinimlistic_1 = require("./ArchiveDownMinimlistic");
__createBinding(exports, ArchiveDownMinimlistic_1, "default", "ArchiveDownMinimlistic");
var ArchiveMinimalistic_1 = require("./ArchiveMinimalistic");
__createBinding(exports, ArchiveMinimalistic_1, "default", "ArchiveMinimalistic");
var ArchiveUp_1 = require("./ArchiveUp");
__createBinding(exports, ArchiveUp_1, "default", "ArchiveUp");
var ArchiveUpMinimlistic_1 = require("./ArchiveUpMinimlistic");
__createBinding(exports, ArchiveUpMinimlistic_1, "default", "ArchiveUpMinimlistic");
var Clipboard_1 = require("./Clipboard");
__createBinding(exports, Clipboard_1, "default", "Clipboard");
var ClipboardAdd_1 = require("./ClipboardAdd");
__createBinding(exports, ClipboardAdd_1, "default", "ClipboardAdd");
var ClipboardCheck_1 = require("./ClipboardCheck");
__createBinding(exports, ClipboardCheck_1, "default", "ClipboardCheck");
var ClipboardHeart_1 = require("./ClipboardHeart");
__createBinding(exports, ClipboardHeart_1, "default", "ClipboardHeart");
var ClipboardList_1 = require("./ClipboardList");
__createBinding(exports, ClipboardList_1, "default", "ClipboardList");
var ClipboardRemove_1 = require("./ClipboardRemove");
__createBinding(exports, ClipboardRemove_1, "default", "ClipboardRemove");
var ClipboardText_1 = require("./ClipboardText");
__createBinding(exports, ClipboardText_1, "default", "ClipboardText");
var Note_1 = require("./Note");
__createBinding(exports, Note_1, "default", "Note");
var Notes_1 = require("./Notes");
__createBinding(exports, Notes_1, "default", "Notes");
var NotesMinimalistic_1 = require("./NotesMinimalistic");
__createBinding(exports, NotesMinimalistic_1, "default", "NotesMinimalistic");
var Paper_1 = require("./Paper");
__createBinding(exports, Paper_1, "default", "Paper");
var PaperAdd_1 = require("./PaperAdd");
__createBinding(exports, PaperAdd_1, "default", "PaperAdd");
var PaperMedicine_1 = require("./PaperMedicine");
__createBinding(exports, PaperMedicine_1, "default", "PaperMedicine");
var Papers_1 = require("./Papers");
__createBinding(exports, Papers_1, "default", "Papers");
var PapersMinimalistic_1 = require("./PapersMinimalistic");
__createBinding(exports, PapersMinimalistic_1, "default", "PapersMinimalistic");
var PaperText_1 = require("./PaperText");
__createBinding(exports, PaperText_1, "default", "PaperText");
